type NotificationSoundKind = "general" | "chat" | "lobby-join";

let audioContext: AudioContext | null = null;
let lastPlayedAt = 0;

function getAudioContext() {
  const AudioContextCtor = window.AudioContext || window.webkitAudioContext;
  if (!AudioContextCtor) return null;
  audioContext ??= new AudioContextCtor();
  return audioContext;
}

function playTone(
  ctx: AudioContext,
  frequency: number,
  startAt: number,
  duration: number,
  gainValue: number
) {
  const oscillator = ctx.createOscillator();
  const gain = ctx.createGain();
  oscillator.type = "sine";
  oscillator.frequency.value = frequency;
  gain.gain.setValueAtTime(0.0001, startAt);
  gain.gain.exponentialRampToValueAtTime(gainValue, startAt + 0.015);
  gain.gain.exponentialRampToValueAtTime(0.0001, startAt + duration);
  oscillator.connect(gain);
  gain.connect(ctx.destination);
  oscillator.start(startAt);
  oscillator.stop(startAt + duration + 0.03);
}

export function playNotificationSound(kind: NotificationSoundKind) {
  if (typeof window === "undefined") return;

  const now = Date.now();
  if (now - lastPlayedAt < 250) return;
  lastPlayedAt = now;

  const ctx = getAudioContext();
  if (!ctx) return;

  void ctx.resume().then(() => {
    const startAt = ctx.currentTime + 0.01;
    if (kind === "chat") {
      playTone(ctx, 740, startAt, 0.09, 0.05625);
      playTone(ctx, 980, startAt + 0.08, 0.12, 0.05);
      return;
    }

    if (kind === "lobby-join") {
      playTone(ctx, 880, startAt, 0.06, 0.055);
      playTone(ctx, 1175, startAt + 0.055, 0.07, 0.05);
      playTone(ctx, 1568, startAt + 0.115, 0.1, 0.045);
      return;
    }

    playTone(ctx, 520, startAt, 0.12, 0.05);
  }).catch(() => {
    // Browser blocked audio until a user gesture. Safe to ignore.
  });
}

declare global {
  interface Window {
    webkitAudioContext?: typeof AudioContext;
  }
}
